import { makeAutoObservable } from 'mobx';

export class Loadable<T>
{
  isLoading: boolean = false;
  private _errorMessage?: string = undefined;
  data?: T = undefined;
  dataRefreshOperator?: () => Promise<void> = undefined;

  constructor()
  {
    makeAutoObservable(this);
  }

  get isError(): boolean
  {
    return this._errorMessage !== undefined;
  }
  get errorMessage(): string
  {
    return this._errorMessage || '';
  }

  setDataRefreshOperator(operator: () => Promise<void>): void
  {
    this.setDataRefreshOperator = operator;
  }
  async refreshAsync()
  {
    try
    {
      if (this.dataRefreshOperator)
      {
        await this.dataRefreshOperator();
      }
    }
    catch (e)
    {
      this.setError(e as Error);
    }
  }
  setIsLoading(isLoading: boolean): void
  {
    this.isLoading = isLoading;
  }
  setError(error: Error): void
  {
    console.log(error);
    this._errorMessage = error.message;
  }
  clearError(): void
  {
    this._errorMessage = undefined;
  }
}